import { render, staticRenderFns } from "./list-table.vue?vue&type=template&id=965beffa&scoped=true&"
import script from "./list-table.vue?vue&type=script&lang=js&"
export * from "./list-table.vue?vue&type=script&lang=js&"
import style0 from "./list-table.vue?vue&type=style&index=0&id=965beffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965beffa",
  null
  
)

export default component.exports